import { useTranslation } from "react-i18next";

/** The two-letter UI language ("cs" for "cs-CZ"), the key every locale-aware lookup takes. */
export const useUiLanguage = () => {
  const { i18n } = useTranslation();

  return i18n.language?.split("-")[0] ?? "en";
};
